type Props = {
  cy?: number;
  cx?: number;
  index?: number;
};

export const HiddenDot = ({ cx = 0, cy = 0, index }: Props) => {
  return (
    <g data-testid={`chart-dot-${index}`}>
      <circle cx={cx} cy={cy} r={1.5} fill="none" />
    </g>
  );
};
